import { AssetType, } from '@zattoo/playback-sdk';
export const PlayerWithRecording = (Base) => {
    return class extends Base {
        playRecording(id, playOptions) {
            return this.requestStream({
                playOptions,
                assetType: AssetType.RECORDING,
                watchRequestParams: {
                    recording_id: id.toString(10),
                },
            });
        }
    };
};
